module.exports = __webpack_public_path__ + "img/close-large.bbb90406.svg";